import type { Article } from "@/platform/compendium";

// The Article surface: a readable prose column with no board and no control bar (visualizer-only
// actions belong on the board view). The compiled HTML is produced at build time by the compileArticle
// macro from trusted in-repo Markdown, so it is injected directly. The shared header, landing index,
// and top tab-strip are v2-02; this v2-01 tracer renders the Article alone.
export function ArticlePage({ article }: { article: Article }) {
  return (
    <main className="article">
      <article
        className="article-body"
        // biome-ignore lint/security/noDangerouslySetInnerHtml: compiled at build from trusted in-repo Markdown
        dangerouslySetInnerHTML={{ __html: article.html }}
      />
    </main>
  );
}
